var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"charge-wallet-view"},[_c('ChargeWallet',{attrs:{"wallet":_vm.wallet,"user":_vm.user,"bankAccounts":_vm.bankAccounts,"mandates":_vm.mandates,"createPayIn":_vm.createPayIn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }